import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { listPartnerAccessKeys } from "./action";

export const keyManagementEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.partnerAccessKey,
});

const initialState = keyManagementEntityAdapter.getInitialState({
  modals: {},
});

export const keyManagementSlice = createSlice({
  name: "keyManagement",
  initialState: initialState,
  reducers: {
    showMultiPurposeKeyManagementModal: (state, action) => {
      state.modals.multiPurposeKeyManagementModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(listPartnerAccessKeys.fulfilled, (state, action) => {
      if (action.payload.status) {
        const { data } = action.payload;

        keyManagementEntityAdapter.setAll(state, data);
      }
    });
  },
});

export const { showMultiPurposeKeyManagementModal } = keyManagementSlice.actions;

export default keyManagementSlice.reducer;
